export default __webpack_public_path__ + "static/media/meta.311a962c.webp";